import { IconName } from '@fortawesome/fontawesome-svg-core';

export enum AdditionalInfoTabType {
  OVERVIEW = 'Overview',
  ASSOCIATED_COMMODITIES = 'Associated Commodities',
  HISTORY = 'History',
  DRAWINGS = 'Drawings',
  COMMODITY_CONNECTIONS = 'Commodity Connections',
}

export interface AdditionalInfoTabItem {
  label: string;
  value: AdditionalInfoTabType;
  icon: IconName;
}
